import React from 'react';
import ReactTable from 'react-table';
import { Checkbox } from 'semantic-ui-react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { TitledCard } from 'Components/';
import { ReactTableWrapper } from 'Common/Components';
import { dateSortMethod } from 'Common/GridHelper';
import { defaultDateFormat } from 'Common/GeneralHelper';
import {
  ScannedApplicationFieldEnum as ScannedAppFields,
  ApplicationFieldEnum as ApplicationFields,
} from 'Common/FieldEnum';

import * as DuplicateAppsSelectors from '../state/duplicateapps/selectors';

const createColumns = (selectedHHId, setSelectedHHid) => {
  return [
    {
      Header: ' ',
      id: 'Checkbox',
      Cell: (props) => {
        const id = props.original[ApplicationFields.Id];
        const checked = selectedHHId === id;
        const disabled = !_.isNil(selectedHHId) && selectedHHId !== id;
        const onChange = () => {
          if (selectedHHId === id) {
            setSelectedHHid(null);
            return;
          }
          setSelectedHHid(id);
        };

        return (
          <Checkbox
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            style={{ marginLeft: 10 }}
          />
        );
      },
      width: 50,
      sortable: false,
      filterable: false,
    },
    {
      Header: 'Last Name',
      accessor: ScannedAppFields.HouseholdLastName,
    },
    {
      Header: 'First Name',
      accessor: ScannedAppFields.HouseholdFirstName,
    },
    {
      Header: 'Address 1',
      accessor: ScannedAppFields.HouseholdAddress1,
    },
    {
      Header: 'Address 2',
      accessor: ScannedAppFields.HouseholdAddress2,
    },
    {
      Header: 'City',
      accessor: ScannedAppFields.City,
    },
    {
      Header: 'State',
      accessor: ScannedAppFields.State,
      width: 40,
    },
    {
      Header: 'Zip Code',
      accessor: ScannedAppFields.Zip,
      width: 65,
    },
    {
      Header: 'Application Date',
      minWidth: 165,
      id: 'ApplicationDate',
      accessor: (row) =>
        defaultDateFormat(row[ScannedAppFields.ApplicationDate]),
      sortMethod: dateSortMethod,
    },
  ];
};

const createSubColumns = () => {
  return [
    {
      Header: ' ',
      width: 35,
    },
    {
      Header: ' ',
      width: 50,
    },
    {
      Header: 'Student Number',
      accessor: ScannedAppFields.MemberStudentNumber,
    },
    {
      Header: 'Last Name',
      accessor: ScannedAppFields.MemberLastName,
    },
    {
      Header: 'First Name',
      accessor: ScannedAppFields.MemberFirstName,
    },
    {
      Header: 'Site',
      accessor: ScannedAppFields.MemberSchoolNumber,
    },
    {
      Header: 'Birth Date',
      id: 'Birth Date',
      accessor: (row) => defaultDateFormat(row[ScannedAppFields.BirthDateDT]),
    },
  ];
};

const SubGrid = (row) => (
  <ReactTable
    className={'review-incoming-applications-sub-grid'}
    data={row.original.Members}
    columns={createSubColumns(row.original.Members)}
    minRows={1}
    showPagination={false}
    filterable={false}
    sortable={false}
    noDataText={'No members found'}
    resizable={false}
    getTheadTrProps={() => ({
      className: 'review-incoming-applications-sub-grid-header',
    })}
  />
);

function DuplicateApplicationsTable({
  duplicateApps,
  loading,
  setSelectedHHId,
  selectedHHId,
  expanded,
  setExpanded,
}) {
  const existingAppTableColumns = React.useMemo(
    () => createColumns(selectedHHId, setSelectedHHId),
    [selectedHHId]
  );

  return (
    <TitledCard title="Select Existing Application">
      <ReactTableWrapper
        loading={loading}
        data={duplicateApps}
        columns={existingAppTableColumns}
        SubComponent={SubGrid}
        filterable={true}
        resizable={false}
        expanded={expanded}
        minRows={5}
        pageSize={5}
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              // The column with the caret to expand has no id (and is the only column with no id)
              if (column.id === undefined) {
                if (expanded[rowInfo.viewIndex]) {
                  setExpanded({
                    [rowInfo.viewIndex]: false,
                  });
                } else {
                  setExpanded({
                    [rowInfo.viewIndex]: true,
                  });
                }
              }
            },
          };
        }}
        onPageChange={() => setExpanded({})}
      />
    </TitledCard>
  );
}

const mapStateToProps = (state, ownProps) => ({
  duplicateApps: DuplicateAppsSelectors.getDuplicateAppsForTable(state),
  loading: DuplicateAppsSelectors.getLoadingDuplicateApps(state),
});

const ConnectedComponent = connect(mapStateToProps)(DuplicateApplicationsTable);

export { ConnectedComponent as DuplicateApplicationsTable };



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/components/DuplicateApplicationsTable.js